import { User } from "../user/user.model";
import { Client } from "../client/client.model";
import { Rate } from "./rate-type";
import { RateLocation } from "./rate-location/rate-location.type";
import { Carrier } from "../carrier/carrier.model";
import { ContainerName } from "../shared/container/container-name.type.const";
import { ContainerPrices } from "../shared/container/container-prices.model";
import { BaseLinkedRate } from "./rate-base-linked.model";

export class FclRate extends BaseLinkedRate {
  constructor(
    protected id: number,
    protected name: string,
    protected discriminator: string,
    protected containers: ContainerPrices = new ContainerPrices([]),
    protected containerMargins: ContainerPrices = new ContainerPrices([]),
    protected totals: ContainerPrices = new ContainerPrices([]),
    protected equipment: ContainerName[] = [],
    protected createdBy?: User,
    protected updatedBy?: User,
    protected createdAt?: Date,
    protected updatedAt?: Date,
    protected type?: string,
    protected source?: string,
    protected status?: string,
    protected internalNote?: string,
    protected externalNote?: string,
    protected pmNote?: string,
    protected comment?: string,
    protected deepLink?: string,
    protected carrier?: Carrier,
    protected validity?: Date[],
    protected currency?: string,
    protected originLocation?: RateLocation,
    protected destinationLocation?: RateLocation,
    protected contractNumber?: string,
    protected availableOnline?: boolean,
    protected restrictedClients?: Client[],
    protected restrictedUsers?: User[],
    protected rootParent?: Rate,
    protected incoterms: string[] = [],
  ) {
    super(
      id,
      name,
      discriminator,
      createdBy,
      updatedBy,
      createdAt,
      updatedAt,
      type,
      source,
      status,
      internalNote,
      externalNote,
      pmNote,
      comment,
      deepLink,
      carrier,
      validity,
      currency,
      originLocation,
      destinationLocation,
      contractNumber,
      restrictedClients,
      restrictedUsers,
      rootParent,
    );
  }

  public getContainers(): ContainerPrices {
    return this.containers;
  }

  public getContainerMargins(): ContainerPrices {
    return this.containerMargins;
  }

  public getEquipment(): ContainerName[] {
    return this.equipment;
  }

  public setEquipment(param: ContainerName[]) {
    this.equipment = param;
  }

  public getAvailableOnline() {
    return this.availableOnline;
  }

  public setAvailableOnline(availableOnline) {
    this.availableOnline = availableOnline;
  }

  public getTotals(): ContainerPrices {
    return this.totals;
  }

  public getIncoterms(): string[] {
    return this.incoterms;
  }

  public setIncoterms(incoterms: string[]): void {
    this.incoterms = incoterms;
  }

  public isValid(): boolean {
    return (
      !!this.name &&
      !!this.originLocation &&
      !!this.destinationLocation &&
      !!this.carrier &&
      !!this.validity &&
      !!this.equipment &&
      this.equipment.length > 0
    );
  }
}
